(() => {
  const init = (carousel) => {
    if (carousel.dataset.ready === 'true') return;

    const slides = Array.from(carousel.querySelectorAll('[data-proof-slide]'));
    if (!slides.length) return;

    const previousButton = carousel.querySelector('[data-proof-previous]');
    const nextButton = carousel.querySelector('[data-proof-next]');
    const previousProfile = carousel.querySelector('[data-proof-previous-profile]');
    const nextProfile = carousel.querySelector('[data-proof-next-profile]');
    const currentNumber = carousel.querySelector('[data-proof-current]');
    const totalNumber = carousel.querySelector('[data-proof-total]');
    const toggle = carousel.querySelector('[data-proof-toggle]');
    const progress = carousel.querySelector('[data-proof-progress]');
    const dots = Array.from(carousel.querySelectorAll('[data-proof-dot]'));
    const duration = Number(carousel.dataset.autoplay || 6500);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let index = 0;
    let timer = null;
    let running = !reduceMotion;

    carousel.style.setProperty('--proof-duration', `${duration}ms`);
    const wrap = (value) => (value + slides.length) % slides.length;
    const profileData = (slide) => ({
      src: slide.dataset.profileSrc,
      alt: slide.dataset.profileAlt
    });

    const updateProfileButton = (button, slide) => {
      if (!button || !slide) return;
      const image = button.querySelector('img');
      const data = profileData(slide);
      image.src = data.src;
      image.alt = data.alt;
    };

    const restartProgress = () => {
      if (!progress) return;
      progress.style.animation = 'none';
      progress.offsetHeight;
      progress.style.animation = '';
    };

    const render = ({ reset = true } = {}) => {
      const activeSlide = slides[index];
      const activeNumber = Number(activeSlide.dataset.proofIndex || index + 1);

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      currentNumber.textContent = String(activeNumber).padStart(2, '0');
      totalNumber.textContent = String(slides.length).padStart(2, '0');
      updateProfileButton(previousProfile, slides[wrap(index - 1)]);
      updateProfileButton(nextProfile, slides[wrap(index + 1)]);
      carousel.classList.toggle('is-running', running);
      toggle.textContent = running ? 'Pause' : 'Play';
      toggle.setAttribute('aria-pressed', running ? 'false' : 'true');

      if (reset) restartProgress();
    };

    const stopTimer = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const startTimer = () => {
      stopTimer();
      if (!running || slides.length < 2) return;
      timer = window.setInterval(() => {
        index = wrap(index + 1);
        render();
      }, duration);
    };

    const move = (direction) => {
      index = wrap(index + direction);
      render();
      startTimer();
    };

    previousButton?.addEventListener('click', () => move(-1));
    nextButton?.addEventListener('click', () => move(1));
    previousProfile?.addEventListener('click', () => move(-1));
    nextProfile?.addEventListener('click', () => move(1));

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        index = dotIndex;
        render();
        startTimer();
      });
    });

    toggle?.addEventListener('click', () => {
      running = !running;
      render();
      startTimer();
    });

    carousel.addEventListener('mouseenter', stopTimer);
    carousel.addEventListener('mouseleave', startTimer);
    carousel.addEventListener('focusin', stopTimer);
    carousel.addEventListener('focusout', startTimer);

    carousel.dataset.ready = 'true';
    render();
    startTimer();
  };

  const mount = (root = document) => {
    root.querySelectorAll('[data-proof-carousel]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount());
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
